export const DebugJson = (props: { value: any } ) => (
  <pre>
    {JSON.stringify( props.value , null, 2)}
  </pre>
);